// @flow strict

import * as React from 'react'
import cx from 'classnames'
import styles from './FeatureDiscoveryGrid.module.scss'

export type Feature = {|
  title: string,
  description: string,
  link?: {|
    text: string,
    href: string,
  |},
  iconSrc: string,
|}

type FeatureDiscoveryProps = {
  features: Feature[],
  linkStyles?: string,
  lightText?: boolean,
  classNames?: { [k: 'icon' | 'feature']: string },
}

const FeatureDiscoveryGrid = ({
  features,
  linkStyles,
  lightText = false,
  classNames,
}: FeatureDiscoveryProps) => {
  if (features == null) return null

  // We only want multiples of 3, no partially filled rows
  const numRows = Math.floor(features.length / 3)
  if (numRows === 0) return null

  const trimmedFeatures = features.slice(0, numRows * 3)

  return (
    <div
      className={cx(styles.featureContainer, classNames && classNames.feature)}
    >
      {trimmedFeatures.map(({ title, description, iconSrc, link }, i) => (
        <div className={styles.feature} key={title + i}>
          {iconSrc && (
            <img
              src={iconSrc}
              alt=""
              className={cx(styles.icon, classNames && classNames.icon)}
            />
          )}
          <h3
            className={cx(
              styles.title,
              lightText ? styles.whiteText : styles.darkText,
            )}
          >
            {title}
          </h3>
          <p
            className={cx(
              styles.description,
              lightText ? styles.whiteText : styles.greyText,
            )}
          >
            {description}
          </p>
          {link && link.text && (
            <p>
              <a
                href={link.href}
                className={cx(
                  styles.link,
                  linkStyles || styles.defaultLinkStyles,
                )}
              >
                {link.text}
              </a>
            </p>
          )}
        </div>
      ))}
    </div>
  )
}

export default FeatureDiscoveryGrid
